import type { ListDataStreams200Item } from "@/api/orval/generated/schemas";

/** Ephemeral generator output — id, display name, unitCategory. See ARCHITECTURE.md § Spec Type Flow. */
export interface ResolvedStream {
    id: number;
    unitCategory: string;
    name: string;
}

/** TreeTag inclination channels — not useful on the zone graph, so drop them at resolve time. */
const EXCLUDED_SENSOR_ELEMENT_NAMES = new Set(["Inclination Angle", "Inclination Direction"]);

// Map API streams to ResolvedStream — host label from list-API hostName, otherwise "Stream {id}".
// unitCategory is passed through for panel grouping.
export function resolveStreams(streams: ListDataStreams200Item[]): ResolvedStream[] {
    return streams
        .filter((stream) => !EXCLUDED_SENSOR_ELEMENT_NAMES.has(stream.sensorElementName ?? ""))
        .map((stream) => ({
            id: stream.id,
            name: stream.hostName ?? `Stream ${stream.id}`,
            unitCategory: stream.unitCategory,
        }));
}
